// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"380":"64b92ff9","667":"2944ede7"}[chunkId] + ".css";
};